export enum DistributionTypes {
  Collection = 'BE77BE35-9709-4239-8B9F-079CA0AB7183',
  Library = 'EFBC0F9C-2B54-46E2-AD8C-86BF17A8AB4B',
  Packages = '57DBB89D-5E6E-4DA6-8853-C77638E68AD4',
  Transport  ='2A979266-B54C-4CB6-A2BF-3F9D750165D4',
}
